// src/pages/SteamCallback.js

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import i18n from 'i18next';

function SteamCallback() {
    const navigate = useNavigate();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        const accessTokenFromUrl = urlParams.get('access_token');
        const accessTokenFromStorage = localStorage.getItem('access_token');
        const accessToken = accessTokenFromUrl || accessTokenFromStorage;
        const refreshToken = urlParams.get('refresh_token');
        const redirectPath = urlParams.get('redirect') || localStorage.getItem('redirectPath') || '/';

        if (accessToken) {
            try {
                const decodedToken = jwtDecode(accessToken);
                const currentTime = Date.now() / 1000;

                if (decodedToken.exp < currentTime) {
                    localStorage.removeItem('access_token');
                    navigate('/error');
                    return;
                }

                if (!decodedToken.username || !decodedToken.roles) {
                    navigate('/error');
                    return;
                }

                if (!Array.isArray(decodedToken.roles)) {
                    navigate('/error');
                    return;
                }

                if (decodedToken.roles.length === 0) {
                    navigate('/error');
                    return;
                }

                const allowedRoles = ['ROLE_USER', 'ROLE_ADMIN'];
                const hasAllowedRole = decodedToken.roles.some(role => allowedRoles.includes(role));
                if (!hasAllowedRole) {
                    navigate('/error');
                    return;
                }

                if (accessToken) {
                    localStorage.setItem('access_token', accessToken);
                }

                if (refreshToken) {
                    localStorage.setItem('refresh_token', refreshToken);
                }

                if (decodedToken.language) {
                    const shortLang = decodedToken.language.includes('-')
                        ? decodedToken.language.split('-')[0]
                        : decodedToken.language;
                    const validLanguages = ['en', 'ru', 'ua', 'ko', 'fr'];
                    if (decodedToken.language && validLanguages.includes(shortLang)) {
                        localStorage.setItem('i18nextLng', shortLang);
                        i18n.changeLanguage(shortLang);
                    } else {
                        localStorage.setItem('i18nextLng', 'en');
                        i18n.changeLanguage('en');
                    }
                }

                if (decodedToken.roles.includes('ROLE_ADMIN')) {
                    navigate('/spa');
                } else {
                    navigate(redirectPath);
                }
            } catch (error) {
                navigate('/error');
            }
        } else {
            navigate('/error');
        }
    }, [navigate]);

    return <div>In progress...</div>;
}

export default SteamCallback;